import { setLocalStorage } from "./common";
import { pageURLs } from "../constants/pageURLs";

// Open the feed's Match tab for a given inventory property. The feed
// (LeftpanelTabContentRight) hydrates the selected property from
// selectedPropertyId by matching Inv_Id, and switches to the Match tab from
// FilterTabKey. Used by the inventory "Matches" pill and the inventory-details
// Matches tab so matches always render on the feed, never inline.
export const goToFeedMatchTab = (navigate, invId) => {
  setLocalStorage("FilterTabKey", "match");
  setLocalStorage("selectedPropertyId", { Inv_Id: invId });
  navigate(pageURLs?.home || "/home");
};

// Synthetic Inv_Id so the Inv_Id-keyed feed selector can hold an MLS listing
// (which has only a ListingKey) without changes.
export const mlsPropertyId = (listingKey) => `mls:${listingKey}`;

export const goToFeedMatchTabForMls = (navigate, listingKey) => {
  setLocalStorage("FilterTabKey", "match");
  setLocalStorage("selectedPropertyId", {
    Inv_Id: mlsPropertyId(listingKey),
    ListingKey: listingKey,
    rowType: "mls",
  });
  navigate(pageURLs?.home || "/home");
};
